/**
 * Luke Davis Mechanical — Theme JS
 */
(function () {
  'use strict';

  /* ── Cross-page hash navigation
     If a URL lands on a page with a #hash that has no matching element
     (e.g. /collections/all#contact), redirect to the correct destination.
  ─────────────────────────────────────────────────────────────────────── */
  var HASH_ROUTES = {
    '#contact':  '/pages/contact',
    '#services': '/#services',
    '#parts':    '/collections/all',
    '#barra':    '/#barra',
    '#why':      '/#why',
    '#hero':     '/'
  };

  (function handleCrossPageHash() {
    var hash = window.location.hash;
    if (!hash) return;
    var el = document.getElementById(hash.slice(1));
    if (el) {
      // Element exists — let the browser handle it, but smooth-scroll
      setTimeout(function () {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 100);
      return;
    }
    // No matching element on this page
    var dest = HASH_ROUTES[hash];
    if (dest) {
      window.location.replace(dest);
    }
  })();

  /* ── Reveal on scroll ────────────────────────────────────────────────── */
  var reveals = document.querySelectorAll('.reveal');
  if (reveals.length && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('visible');
          observer.unobserve(e.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    reveals.forEach(function (el) { observer.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('visible'); });
  }

  /* ── Smooth in-page anchor scroll ───────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href^="#"]');
    if (!a) return;
    var id = a.getAttribute('href').slice(1);
    if (!id) return;
    var target = document.getElementById(id);
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    // Close mobile nav if open
    var mobileNav = document.getElementById('mobile-nav');
    if (mobileNav) mobileNav.classList.remove('open');
    // Update URL hash without jump
    if (history.pushState) history.pushState(null, null, '#' + id);
  });

  /* ── Cart: remove item ───────────────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-remove-key]');
    if (!btn) return;
    var key = btn.getAttribute('data-remove-key');
    if (!key) return;
    btn.textContent = '…';
    btn.disabled = true;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    }).then(function () { location.reload(); })
      .catch(function () { btn.textContent = 'Remove'; btn.disabled = false; });
  });

  /* ── Cart qty + / - buttons ─────────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var inc = e.target.closest('[data-cart-qty-inc]');
    var dec = e.target.closest('[data-cart-qty-dec]');
    var btn = inc || dec;
    if (!btn) return;
    var row   = btn.closest('.cart-item');
    var input = row && row.querySelector('.qty-input');
    if (!input) return;
    var val = parseInt(input.value, 10) || 1;
    input.value = inc ? val + 1 : Math.max(0, val - 1);
  });

  /* ── Variant selector on default product page ───────────────────────── */
  var variantSel = document.querySelector('[data-variant-select]');
  if (variantSel) {
    variantSel.addEventListener('change', function () {
      var opt   = this.options[this.selectedIndex];
      var price = opt.getAttribute('data-price');
      var avail = opt.getAttribute('data-available');
      var dispEl = document.querySelector('[data-price-display]');
      var btnEl  = document.querySelector('[data-add-to-cart-btn]');
      if (dispEl && price) dispEl.textContent = price;
      if (btnEl) {
        btnEl.disabled    = avail === 'false';
        btnEl.textContent = avail === 'false' ? 'Sold Out' : 'Add to Cart';
      }
    });
  }
})();
